import { defineStore } from 'pinia'
import type {UnwrapRef} from 'vue'
import { useTableStore } from '@/composables/useTableStore'
import { tableModules } from '@/utils/tableModules'

type TableModuleKeys = keyof typeof tableModules
type TableStoreInstance = UnwrapRef<ReturnType<typeof useTableStore>>
type TableStoreDefinition = () => TableStoreInstance
type TableStores = { [K in TableModuleKeys]: TableStoreDefinition }

function createTableStores() {
    const storeModules: Partial<TableStores> = {}
    for (const registeredModule of Object.keys(tableModules) as TableModuleKeys[]) {
        const storeDef = defineStore(registeredModule, () => {
            const tableStore = useTableStore()
            tableStore.initialize(registeredModule)
            return { ...tableStore }
        })
        storeModules[registeredModule] = storeDef as unknown as TableStoreDefinition
    }
    return storeModules as TableStores
}

export const tableStores = createTableStores()
export type { TableStores, TableStoreInstance, TableStoreDefinition }
